<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="tw-inline-flex"
  >
    <path
      d="M14.5001 1.66675V20.3334M8.66675 8.66675L6.33342 11.0001L8.66675 13.3334M1.66675 4.00008C1.66675 3.38124 1.91258 2.78775 2.35017 2.35017C2.78775 1.91258 3.38124 1.66675 4.00008 1.66675H18.0001C18.6189 1.66675 19.2124 1.91258 19.65 2.35017C20.0876 2.78775 20.3334 3.38124 20.3334 4.00008V18.0001C20.3334 18.6189 20.0876 19.2124 19.65 19.65C19.2124 20.0876 18.6189 20.3334 18.0001 20.3334H4.00008C3.38124 20.3334 2.78775 20.0876 2.35017 19.65C1.91258 19.2124 1.66675 18.6189 1.66675 18.0001V4.00008Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
<script lang="ts" setup>
export interface IProps {
  fill?: string;
  width?: string;
  height?: string;
}

withDefaults(defineProps<IProps>(), {
  width: "16px",
  height: "16px",
});
</script>
